const dec2hex = (dec: number): string => dec.toString(16).padStart(2, '0');

/**
 * Генерирует короткую DOM/CSS-безопасную случайную строку (hex).
 *
 * Используется как `placeId` смонтированного баннера: значение должно быть уникальным между
 * независимыми React-корнями на странице, поэтому React `useId()` не подходит. Реализация
 * повторяет то, как `@cian/mf-registry` генерирует `instance.id`.
 */
export const generateRandomString = (length = 8): string => {
  const randomArray = new Uint8Array(length / 2);

  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(randomArray);
  } else {
    randomArray.forEach((_, index) => {
      randomArray[index] = Math.floor(Math.random() * 256);
    });
  }

  return Array.from(randomArray, dec2hex).join('');
};
